import { render, staticRenderFns } from "./DayView.vue?vue&type=template&id=2bb28a6c&scoped=true"
import script from "./DayView.vue?vue&type=script&lang=js"
export * from "./DayView.vue?vue&type=script&lang=js"
import style0 from "./DayView.vue?vue&type=style&index=0&id=2bb28a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb28a6c",
  null
  
)

export default component.exports